import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="11" height="17" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...props}><path d="M2.06 4.81a3.44 3.44 0 016.88 0v1.72H2.06V4.81zm8.25 0v1.72l.69.69v8.25l-.69.69H.7l-.69-.7V7.23l.69-.69V4.81a4.81 4.81 0 019.62 0zm-3.78 5.5c0 .45-.29.83-.69.97v1.44h-.68v-1.44a1.03 1.03 0 111.37-.97z" fill="#FFF" fillRule="evenodd" /></svg>);